import React from "react"

function Loader() {
  return (
    <div className="wr-search-loader">
      <div className="loader search-loader"></div>
    </div>
  )
}

export default Loader
